import script from "./PaginationLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationLoader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__